import React from 'react';
import SendingPopup from '../../../component/sendingPopup/SendingPopup';
import {useSelector} from 'react-redux';
import {TState} from '../../../redux/store.type';
import {TShow} from '../../../component/prompotionPopup/PromotionPopup';
import useRestartXHR from '../../../hooks/useRestartXHR';
import {useSend} from '../../../component/sendingPopup/hooks/useSend';
import {createSendingProps} from '../../../component/sendingPopup/services/createSendingProps';
import {useSendData} from '../../../hooks/useSendData';
import {useTranslation} from 'react-i18next';
import {sendLeadsMessage} from '../../../redux/publish/publishActions';

function LeadSendPopup({show}: {show: TShow}) {
    const leads = useSelector((state: TState) => state.branding.leads);
    const sendingXHR = useSelector((state: TState) => state.publish.sendLeadsXHR);
    const {t} = useTranslation('mailing');

    // Custom hooks for data management and send logic
    const {whatsappData, emailData, smsData, handleDataSave, whatsappTemplate} = useSendData({
        defaultMessage: t('mailingLeadDefaultText'),
        defaultSubject: t('subjectDefaultText'),
        defaultEmailBody: `${t('leadMessageTitle')}\n${t('mailingLeadDefaultText')}\n [ref_link]`,
        defaultSmsMessage: `${t('leadMessageTitle')}\n${t('mailingLeadDefaultText')}\n [ref_link]`,
        type: 'lead'
    });
    const {handleSend} = useSend({whatsappData, emailData, smsData, show, sendFunction: sendLeadsMessage, data: {leads: leads}});

    // XHR restart hook
    useRestartXHR(sendingXHR, 'publish.sendLeadsXHR');

    // Create props using utility function
    const {whatsappProps, emailProps, smsProps} = createSendingProps({
        whatsappData,
        emailData,
        smsData,
        handleDataSave,
        handleSend,
        sendingXHR,
        whatsappTemplate,
        variablesType: 'lead'
    });
    
    return (
        <>
            {show.isOpen && (
                <SendingPopup 
                    show={show} 
                    whatsappProps={whatsappProps} 
                    smsProps={smsProps} 
                    emailProps={emailProps}
                    amount={leads.length}
                    amountText={'leads'}
                    variablesType={'lead'}
                    allowedList={['whatsapp', 'email', 'sms']}
                />
            )}
        </>
    );
}

export default LeadSendPopup; 